import { Box, Typography } from "@mui/material";
import { DropdownModel } from "../../../data/interfaces/sharedmodels";

export default function VersionDetails({systemInfo}:{systemInfo:DropdownModel[]}){
    return(
        <Box>
            <Typography variant="h6">Software Version : <strong>{systemInfo.findIndex(a=>a.Id=="AppVersion")>-1?systemInfo.filter(a=>a.Id=="AppVersion")[0].Description :'2.0.0'}</strong></Typography>
            <Typography variant="h6">Database Version : <strong> {systemInfo.findIndex(a=>a.Id=="BDPVersion")>-1?systemInfo.filter(a=>a.Id=="BDPVersion")[0].Description :'2.0.0'}</strong></Typography>
            <Typography variant="h6">Part Number : <strong>{systemInfo.findIndex(a=>a.Id=="PartNumber")>-1?systemInfo.filter(a=>a.Id=="PartNumber")[0].Description :'2.0.0'}</strong></Typography>
        </Box>
    )
}